module.exports = __webpack_public_path__ + "static/media/landing_mobile.bb70b1fb.jpg";